import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';

const routes: Routes = [
  {
    path: '',
    // component: AppComponent,
    loadChildren: () =>
      import('./landing-page/landing-page.module').then(
        (m) => m.LandingPageModule
      ),
  },
  {
    path: 'old-page',
    pathMatch: 'prefix',
    // component: AppComponent,
    loadChildren: () =>
      import('./public-page/public-page.module').then(
        (m) => m.PublicPageModule
      ),
  },
  {
    path: 'school',
    pathMatch: 'prefix',
    // component: AppComponent,
    loadChildren: () =>
      import('./new-page/new-page.module').then((m) => m.NewPageModule),
  },
  {
    path: 'admit',
    pathMatch: 'prefix',
    // component: AppComponent,
    loadChildren: () =>
      import('./admission-flow/admission-flow.module').then(
        (m) => m.AdmissionFlowModule
      ),
  },
  {
    path: 'job',
    pathMatch: 'prefix',
    // component: AppComponent,
    loadChildren: () =>
      import('./app-job/app-job.module').then((m) => m.AppJobModule),
  },
  {
    path: 'tools',
    pathMatch: 'prefix',
    // component: AppComponent,
    loadChildren: () =>
      import('./app-tools/app-tools.module').then((m) => m.AppToolsModule),
  },
  {
    path: '**',
    // component: AppComponent,
    loadChildren: () =>
      import('./error/error.module').then((m) => m.ErrorModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      initialNavigation: 'enabledBlocking',
      // useHash: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
